export const promotionOrSaleJson = {
  page: {
    body: {
      container: { style: { 'background-color': '#FFFFFF' } },
      content: {
        computedStyle: { linkColor: '#ff819c', messageBackgroundColor: 'transparent', messageWidth: '700px' },
        style: { color: '#000000', 'font-family': "Arial, 'Helvetica Neue', Helvetica, sans-serif" },
      },
      type: 'mailup-bee-page-properties',
      webFonts: [],
    },
    description: 'empty-dutchie-template',
    rows: [
      {
        columns: [
          {
            'grid-columns': 12,
            mobileStyle: {
              'padding-bottom': '40px',
              'padding-left': '24px',
              'padding-right': '24px',
              'padding-top': '40px',
            },
            modules: [
              {
                descriptor: {
                  computedStyle: { class: 'center fixedwidth', hideContentOnMobile: false, width: '124px' },
                  image: {
                    alt: '',
                    height: '140px',
                    href: '',
                    percWidth: 20,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/yub/3ji/j88/Dispo%20Logos.png',
                    target: '_blank',
                    width: '252px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '40px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: 'f20d4d50-a604-49a3-8e76-79373bd0e109',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#ffffff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '48px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">Mix &amp; Match Thursday</span>',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '32px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '9f474de3-744d-4eae-baad-79dfd98cc332',
              },
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  mobileStyle: { 'font-size': '14px' },
                  paragraph: {
                    computedStyle: { linkColor: '#0075e0', paragraphSpacing: '16px' },
                    html: '<p>Lorem Ipsum has been the industry&#39;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>',
                    style: {
                      color: '#ffffff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '16px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '48px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: '529b98d7-b577-4c73-8344-08072a4e70e2',
              },
              {
                descriptor: {
                  button: {
                    label:
                      '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p style="word-break:break-word;" data-mce-style="word-break:break-word;">View Promotions</p></div>',
                    percWidth: 52,
                    style: {
                      'background-color': '#0075e0',
                      'border-bottom': '0px solid transparent',
                      'border-left': '0px solid transparent',
                      'border-radius': '4px',
                      'border-right': '0px solid transparent',
                      'border-top': '0px solid transparent',
                      color: '#ffffff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '16px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '200%',
                      'max-width': '100%',
                      'padding-bottom': '12px',
                      'padding-left': '20px',
                      'padding-right': '20px',
                      'padding-top': '12px',
                      width: '60%',
                    },
                    target: '_blank',
                  },
                  computedStyle: { height: 56, hideContentOnMobile: false, width: 324 },
                  mobileStyle: {
                    'font-size': '14px',
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '40px',
                    'padding-right': '40px',
                    'padding-top': '0px',
                    'text-align': 'center',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-button',
                uuid: 'a2bca2e2-e72b-4288-b661-1da1ec151ad7',
              },
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  mobileStyle: { 'font-size': '12px' },
                  paragraph: {
                    computedStyle: { linkColor: '#ff819c', paragraphSpacing: '16px' },
                    html: '<p>BEFORE TIME RUNS OUT</p>',
                    style: {
                      color: '#fff',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '14px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '40px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: '3eb07560-0daf-482c-b03f-3dfdf60e4006',
              },
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '620px',
                  },
                  image: {
                    alt: '',
                    height: '656px',
                    href: '',
                    percWidth: 100,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/a6j/y54/mkt/Promo_Photo.jpg',
                    target: '_blank',
                    width: '1200px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '06646bdf-aa35-4284-b38a-483eba19e555',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '48px',
              'padding-left': '40px',
              'padding-right': '40px',
              'padding-top': '60px',
            },
            uuid: 'cb911f58-1e3e-4d35-9717-73e278881987',
          },
        ],
        container: {
          style: {
            'background-color': '#10304d',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-radius': '0px',
            color: '#333',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '4bf4a6fc-45d2-41ae-a96c-1604a93d8e16',
      },
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#0b192c',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '32px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">Today’s Deals</span>',
                    title: 'h2',
                  },
                  mobileStyle: { 'font-size': '24px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '6af69b91-c021-40a6-ad72-ddafeadc3b29',
              },
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  mobileStyle: { 'font-size': '16px' },
                  paragraph: {
                    computedStyle: { linkColor: '#0075e0', paragraphSpacing: '16px' },
                    html: '<p>Get 20% off select North Cannabis Co. products</p>',
                    style: {
                      color: '#646d72',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '20px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: 'd27fd53e-967b-4163-be86-98ec7a366a34',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '40px',
              'padding-left': '40px',
              'padding-right': '40px',
              'padding-top': '40px',
            },
            uuid: '10d97d62-fa26-4f7d-89cc-b23b699f70e3',
          },
        ],
        container: {
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: 'b3b6775d-9c54-4ff5-a093-24f17a4c4a9e',
      },
      {
        columns: [
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '210px',
                  },
                  image: {
                    alt: '',
                    height: '540px',
                    href: '',
                    percWidth: 60,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/bmr/6uu/44t/pre-roll-1.jpg',
                    target: '_blank',
                    width: '540px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '992c0766-c16d-4244-9fba-65dd75fb708f',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': 'inherit',
                      'font-size': '20px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">Deal #1</span>',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '16px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '4c61227c-91b4-4c8e-9231-d0a6bf92a011',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '32px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '0px',
            },
            uuid: 'ec41060a-5067-4392-852d-bf30c5bba42e',
          },
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '210px',
                  },
                  image: {
                    alt: '',
                    height: '540px',
                    href: '',
                    percWidth: 60,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/o14/geo/ex0/pre-roll-2.jpg',
                    target: '_blank',
                    width: '540px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: 'c90b3aaf-0947-4c39-80f1-22dab97118e8',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': 'inherit',
                      'font-size': '20px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">Deal #2</span>',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '16px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '369ae7f0-4189-4b0a-92c7-b17866a99aca',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '0px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '0px',
            },
            uuid: '03f2c724-a373-4c5a-9001-113229524a7a',
          },
        ],
        container: {
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'two-columns-empty',
        uuid: '291e451e-2a4c-4e3c-ad74-85cf09053fe2',
      },
      {
        columns: [
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '210px',
                  },
                  image: {
                    alt: '',
                    height: '540px',
                    href: '',
                    percWidth: 60,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/v2l/r3a/pao/pre-roll-3.jpg',
                    target: '_blank',
                    width: '540px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: '0fa3a2c5-4140-4bf8-92f7-ec7da38b8e01',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': 'inherit',
                      'font-size': '20px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">Deal #3</span>',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '16px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '72132949-69ac-45f6-82cc-3f0fea77742d',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '5px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '5px',
            },
            uuid: 'ec41060a-5067-4392-852d-bf30c5bba42e',
          },
          {
            'grid-columns': 6,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth fullwidthOnMobile',
                    hideContentOnMobile: false,
                    width: '210px',
                  },
                  image: {
                    alt: '',
                    height: '540px',
                    href: '',
                    percWidth: 60,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/pub/c524/b1oxpgm8/bv9/s65/trq/pre-roll-3-1.jpg',
                    target: '_blank',
                    width: '540px',
                  },
                  style: {
                    'border-radius': '0px',
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: 'c46f5203-2b61-47b5-b591-3cdfb02dd1df',
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnDesktop: false, hideContentOnMobile: false },
                  heading: {
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': 'inherit',
                      'font-size': '20px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '120%',
                      'link-color': '#0075e0',
                      'text-align': 'center',
                    },
                    text: '<span class="tinyMce-placeholder">Deal #4</span>',
                    title: 'h1',
                  },
                  mobileStyle: { 'font-size': '16px' },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '16px',
                    'padding-right': '16px',
                    'padding-top': '16px',
                    'text-align': 'center',
                    width: '100%',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-heading',
                uuid: '9e287621-3a6d-4f9f-a4f7-13784f7940a4',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '5px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '5px',
            },
            uuid: '03f2c724-a373-4c5a-9001-113229524a7a',
          },
        ],
        container: {
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'two-columns-empty',
        uuid: '39c077b3-6f18-4302-b9ea-8be897b7c73c',
      },
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {
                  button: {
                    label:
                      '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p style="word-break:break-word;" data-mce-style="word-break:break-word;">View Promotions</p></div>',
                    percWidth: 52,
                    style: {
                      'background-color': '#ffffff',
                      'border-bottom': '2px solid #0075e0',
                      'border-left': '2px solid #0075e0',
                      'border-radius': '4px',
                      'border-right': '2px solid #0075e0',
                      'border-top': '2px solid #0075e0',
                      color: '#0075e0',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '16px',
                      'font-weight': '700',
                      'letter-spacing': '0px',
                      'line-height': '200%',
                      'max-width': '100%',
                      'padding-bottom': '12px',
                      'padding-left': '20px',
                      'padding-right': '20px',
                      'padding-top': '12px',
                      width: '60%',
                    },
                    target: '_blank',
                  },
                  computedStyle: { height: 60, hideContentOnMobile: false, width: 362 },
                  mobileStyle: {
                    'font-size': '14px',
                    'padding-bottom': '24px',
                    'padding-left': '24px',
                    'padding-right': '24px',
                    'padding-top': '24px',
                  },
                  style: {
                    'padding-bottom': '48px',
                    'padding-left': '48px',
                    'padding-right': '48px',
                    'padding-top': '48px',
                    'text-align': 'center',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-button',
                uuid: '586a4b4d-4a6a-45c6-beed-dc0c00eedaea',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '5px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '5px',
            },
            uuid: 'b8d0a513-160b-4a70-94dd-0519b55c3f47',
          },
        ],
        container: {
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '11f6b767-fb42-4bbd-ab68-bc07ace0221b',
      },
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    hideContentOnAmp: false,
                    hideContentOnDesktop: false,
                    hideContentOnHtml: false,
                    hideContentOnMobile: false,
                  },
                  paragraph: {
                    computedStyle: { linkColor: '#0075e0', paragraphSpacing: '16px' },
                    html: '<p>Questions? Please refer to our FAQs or emailus at <u>hello@northcannabisco.com.</u><br/>Copyright © 2024 Dutchie, Inc - All Rights Reserved.<br/>2728 North West Potts Court, Bend OR, 97701</p>',
                    style: {
                      color: '#121516',
                      direction: 'ltr',
                      'font-family': "'Helvetica Neue', Helvetica, Arial, sans-serif",
                      'font-size': '12px',
                      'font-weight': '400',
                      'letter-spacing': '0px',
                      'line-height': '180%',
                      'text-align': 'center',
                    },
                  },
                  style: {
                    'padding-bottom': '16px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                  },
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-paragraph',
                uuid: 'ed02a55f-cba5-42ae-addd-a9e424cddb4f',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '1px solid #e3e7e9',
              'padding-bottom': '48px',
              'padding-left': '48px',
              'padding-right': '48px',
              'padding-top': '48px',
            },
            uuid: 'cf39019a-697d-42e0-8e98-01d65f8a437b',
          },
        ],
        container: {
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top',
          },
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            'border-bottom': '0px solid transparent',
            'border-left': '0px solid transparent',
            'border-radius': '0px',
            'border-right': '0px solid transparent',
            'border-top': '0px solid transparent',
            color: '#000000',
            width: '700px',
          },
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '455427c0-6739-421d-ad61-52cdaf6ffd1f',
      },
    ],
    template: { name: 'template-base', type: 'basic', version: '2.0.0' },
    title: 'empty-dutchie-template',
  },
  comments: {},
};
